import {useDispatch} from 'react-redux';
import {setRequired} from '../service/createForm.slice';

export const useToggleRequired = () => {
  const dispatch = useDispatch();
  const toggleRequired = idx => {
    dispatch(setRequired({idx}));
  };
  return {
    toggleRequired,
  };
};
